import { Component, forwardRef } from '@angular/core';
import { ArrayDataSource } from "@airnauts/ng-components";
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from "@angular/forms";
import { SortDirection, UserSortDefinitionInput, UserSortField } from "@/core/graphql/graphql";

@Component({
  selector: 'cosmos-date-sorting-select',
  templateUrl: './date-sorting-select.component.html',
  styleUrls: ['./date-sorting-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DateSortingSelectComponent),
      multi: true,
    },
  ],
})
export class DateSortingSelectComponent implements ControlValueAccessor {
  private _onChange: (_: any) => void;

  private readonly _selectOptions: string[] = ['Don\'t apply', 'By newest', 'By oldest'];
  private readonly _initialValue: string = this._selectOptions[1];

  public readonly _selectDataSource = new ArrayDataSource(this._selectOptions);
  public readonly _formControl = new FormControl(this._initialValue);

  public constructor() {
    this._formControl.valueChanges.subscribe(next => {
      next ? this._onChange(this.mapToUserSortDefinitionInputArray(next)) : this.forceSelectionInSelect();
    });
  }

  public registerOnChange(fn: (_: any) => void): void {
    this._onChange = fn;
    this._onChange(this.mapToUserSortDefinitionInputArray(this._initialValue));
  }

  public registerOnTouched(fn: any): void { }

  public setDisabledState(isDisabled: boolean): void { }

  public writeValue(obj: any): void {
    if (this._onChange !== undefined) {
      this._formControl.patchValue(obj);
    }
  }

  private mapToUserSortDefinitionInputArray(value: string | undefined): UserSortDefinitionInput {
    let result: UserSortDefinitionInput;

    if (value === this._selectOptions[1]) {
      result = { sortField: UserSortField.CreatedAt, sortDirection: SortDirection.Desc };
    } else if (value === this._selectOptions[2]) {
      result = { sortField: UserSortField.CreatedAt, sortDirection: SortDirection.Asc };
    }

    // @ts-ignore
    return result;
  }

  private forceSelectionInSelect(): void {
    if (!this._formControl.value) {
      this._formControl.patchValue(this._selectOptions[0]);
    }
  }
}
